/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const root = (typeof window !== "undefined") ? window : globalThis;

root.selectSampleSurvey = () => $('[data-js-sample-survey]').on('change', function() {
  const url = $('[data-js-sample-survey]:checked').val();
  if (url) {
    $('.disabled_step').addClass('hide');
    $('.enabled_step').removeClass('hide');
    return $('#sample-survey-btn, .enabled_step a').attr('href', url);
  }
});

/*
$(function() {
  selectSampleSurvey();
  return $('[data-js-sample-survey]').change();
});
*/

function initSampleSurveysOnLoad() {
  if ($('[data-js-sample-survey]').length) {
    selectSampleSurvey();
    $('[data-js-sample-survey]').change();
  }
}

$(initSampleSurveysOnLoad);
document.addEventListener('turbo:load', initSampleSurveysOnLoad);
